import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom';
import DrivesMap from './modules/DrivesMap';
/**
 * Constants
 */
const driveTimesMap = document.getElementById('drive-times-map');
if (driveTimesMap) {
    ReactDOM.render(_jsx(DrivesMap, {}), driveTimesMap);
}
